import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import OurHomesContent from '../components/OurHomesContent';
import Footer from '../components/Footer';

const OurHomes = () => {
  return (
    <div className="OurHomes">
      <Header />
      <div className="mt-32 sm:mt-36 lg:mt-32">
        <Hero
          image="/assets/images/Our%20Homes.jpg"
          heightClass="min-h-[50vh] sm:min-h-[60vh] lg:min-h-[70vh]"
          mobilePosition="center center"
        />
        <div className="h-1 w-full bg-[#2f4c74]"></div>
        <OurHomesContent />
        <Footer />
      </div>
    </div>
  );
};

export default OurHomes;
